/*
 *路由转换器
 *将JSON格式的菜单转成路由
 */
import api from "@/apis/system"
import console from '@/views/main/index.vue'

export default function () {
  return api.auth.menus().then(res => {
    let routers = filterRouter(res)
    return routers
  })
}

//格式化路由(过滤路由器)
const filterRouter = (data) => {
  let routers = []
  data.forEach((item) => {
    let router = {}
    router = {
      path: item.Path,
      name: item.Id,
      component: requireComponent(item.Component),
      meta: {
        title: item.Title,
        icon: item.Icon,
        position: item.Component,
        auth: true,
        hidden: !item.State,
      },
    }
    if (item.Redirect) {
      router.redirect = item.Redirect
    }
    if (item.children) {
      router.children = filterRouter(item.children)
    }
    routers.push(router)
  })
  return routers
}

//载入路由依赖
const requireComponent = (component) => {
  try {
    switch (component) {
      case 'console': {
        return console
      }
      default: {
        if (component) {
          return require('@/views' + component + '.vue').default
        } else {
          return { render: (c) => c('router-view') }
        }
      }
    }
  } catch (err) {
    return require('@/views/error/404.vue').default
  }
}
